module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor001"
    }
  }, [_vm._v("1 Learning to Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor007"
    }
  }, [_vm._v("2 The How-To Sex Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Talking Topics: Ages Nine to Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Where Did My Little Girl Go?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Back Story")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The How-Not-To Sex Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Talking Topics: Ages Thirteen to Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idTextAnchor035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Fear Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idTextAnchor038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Overcoming Fear and Shame")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgments#_idTextAnchor041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixA#_idTextAnchor042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: Resources for The Talks")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixB#_idTextAnchor043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Sexual Abuse and Violence")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendixC#_idTextAnchor049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: Talking Topics")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Facing “The Talk”")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author#_idTextAnchor088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/crescendo#_idTextAnchor089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crescendo")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#_idTextAnchor090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0